import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Select, Row, Col } from "antd";
import { DataTable, RadioGroup, Button } from '@life-line-lab/components-react';
import { map } from 'lodash';
import { Empty } from 'antd';
import './products.scss';

const ChooseProducts = ({ productList, selectedProducts }) => {

    const { t } = useTranslation();
    const [selectedIndex, setSelectedIndex] = useState<any>({})

    useEffect(() => {

    }, [])

    const onProductSelect = (val) => {
        setSelectedIndex(val)
    }

    const onSubmit = () => {
        selectedProducts(productList[selectedIndex])
    }

    // console.log(productList)

    return (
        <div className="">
            <h2 className="center">{t('title.chooseProducts')}</h2>
            <div className="fixed-box">
                <div>
                    {productList.length == 0 ?
                        <div style={{ marginTop: '100px', fontSize: '22px', textAlign: 'center' }}>
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={
                                <span>
                                    {t('title.noProductsFound')}
                                </span>
                            } />

                        </div> : null}
                </div>
                <RadioGroup
                    direction="vertical"
                    name="product"
                    value={selectedIndex}
                    onChange={(event) => onProductSelect(event.target.value)}
                    options={map(productList, (prod, i) => {
                        let amount = prod.stockVariants.length ? prod.stockVariants[0].value : 0;
                        return {
                            value: i, label:
                                <div className="products">
                                    <Row gutter={16}>
                                        <Col lg={1} md={1} sm={1} xs={0} className="info"></Col>
                                        <Col lg={4} md={4} sm={4} xs={6} className="img flex-align-center">
                                            <img
                                                alt={t('alt.logo')}
                                                src={prod?.product?.images ? prod?.product?.images[0]?.file_data?.file_url : ''}
                                                style={{ width: '50px', height: '50px' }}
                                            /> &nbsp;
                                        </Col>
                                        <Col lg={16} md={16} sm={16} xs={16} className="info">
                                            <div style={{ textTransform: 'capitalize', fontSize: '16px' }}> <strong>{prod.product.productName}</strong></div>
                                            <h4 className="" style={{ color: '#365BA9' }}><strong>RM {amount}</strong></h4>
                                        </Col>
                                    </Row>
                                </div>
                        }
                    })}
                />
            </div>
            <div className="center">
                {/* <Button
                    type="primary"
                    label={t('action.submit')}
                    size="large"
                    onClick={onSubmit}
                /> */}
                {productList.length ?
                    <Button
                        type="primary"
                        label={t('action.submit')}
                        size="large"
                        onClick={onSubmit}
                    /> : null}
            </div>

        </div>
    );
};

export default ChooseProducts;